import Layout from './layout';
import Sider from './Sider';
Layout.Sider = Sider;
export default Layout;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/layout/index.js
// module id = null
// module chunks = 